import cn from 'classnames';
import React, { memo, useMemo } from 'react';

import { Layout, Tabs } from '@sravni/react-design-system';

import { PRODUCT_DESCRIPTION_ANCHOR } from '@src/constants/common';
import { useCard } from '@src/reducers/product';

import { Conditions } from './Conditions';
import { Delivery } from './Delivery';
import { Rates } from './Rates';
import { Requirements } from './Requirements';
import styles from './styles.module.scss';

interface IProps {
  className?: string;
}

const ProductInfo: React.FunctionComponent<IProps> = memo((props: IProps) => {
  const { className } = props;
  const card = useCard();

  const description = useMemo(
    () =>
      card.description ? (
        <>
          <h2 className={styles.heading}>Описание</h2>
          <div className={styles.content_block} dangerouslySetInnerHTML={{ __html: card.description }} />
        </>
      ) : null,
    [card.description],
  );

  return (
    <div className={cn(styles.wrapper, className)} id={PRODUCT_DESCRIPTION_ANCHOR}>
      <div className={styles.container}>
        <Layout className={styles.layout}>{description}</Layout>
        <Tabs className={styles.tabs}>
          <Tabs.TabPane title="Ставки">
            <Rates />
          </Tabs.TabPane>
          <Tabs.TabPane title="Условия">
            <Conditions />
          </Tabs.TabPane>
          <Tabs.TabPane title="Выдача">
            <Delivery />
          </Tabs.TabPane>
          <Tabs.TabPane title="Требования">
            <Requirements />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
});

export default ProductInfo;
